module.exports = __webpack_public_path__ + "static/media/hand_wave.2eefdf88.gif";